import { Injectable } from '@angular/core';
import { ICard, ICardVariant } from '../../model/i-card';

@Injectable({
  providedIn: 'root'
})
export class Newbie {
  private isPointsMax: ICardVariant;
  private isPointsMin: ICardVariant;

  cardForNewBie(card: ICard): ICard{
    this.clearValues();
    if(card.data.variants_type && card.data.variants){
      this.cardMin(card.data.variants);
      this.cardMax(card.data.variants);
      if(card.data?.variants_type === 'checkbox' && !this.isObjectNotEmpty(this.isPointsMin)){
        this.isPointsMin = card.data.variants[card.data.variants.length -1];
      }
      card.data.variants = [];
      card.data.variants.push(this.isPointsMax);
      if(this.isObjectNotEmpty(this.isPointsMin)){
        card.data.variants.push(this.isPointsMin);
      }
    }
    return card;
  }

  private cardMax(lists: ICardVariant[]){
    lists.forEach((item: ICardVariant)=>{
      if(item.v_points > 0){
        if(!this.isObjectNotEmpty(this.isPointsMax)){
          this.isPointsMax = item;
        } else{
          if(this.isPointsMax.v_points < item.v_points){
            this.isPointsMax = {... item};
          }
        }
      }
    });
  }

  private cardMin(lists: ICardVariant[]){
    lists.forEach((item: ICardVariant) =>{
      if(item.v_points < 0){
        if(!this.isObjectNotEmpty(this.isPointsMin)){
          this.isPointsMin = item;
        } else{
          if(this.isPointsMin.v_points > item.v_points){
            this.isPointsMin = {... item};
          }
        }
      }
    });
  }


  private isObjectNotEmpty<T extends object>(obj: T): boolean {
    return Object.keys(obj).length > 0;
  }

  private clearValues(){
    this.isPointsMax = {} as ICardVariant;
    this.isPointsMin = {} as ICardVariant;
  }
  
}
